import React from 'react';
import { Form as AntdForm, Button } from 'antd';
import createDecorator from 'final-form-focus';
import * as yup from 'yup';
import Modal from 'react-modal';
import { assoc } from 'ramda';
import { Field, Form } from 'react-final-form';

import LanguageContext from './LanguageContext';
import Input from './formComponents/Input';
import { CloseOutlined } from '@ant-design/icons';

const focusOnErrors = createDecorator();

const validationSchema = yup.object().shape({
    comment: yup.string().required(),
});

const CancelOpdModal = props => {
    const renderForm = formProps => {
        const { handleSubmit, submitFailed } = formProps;

        return <AntdForm onFinish={handleSubmit} noValidate>
            <Field
                name='comment'
                component={Input}
                placeholder={props.t('fields.cancelReason')}
                rows={4} />
            <div className="container">
                <div className="controls">
                    <Button
                        className='cancel-button'
                        onClick={props.onRequestClose}>
                        {props.t('cancel')}
                    </Button>
                    <Button
                        type='primary'
                        className={submitFailed && 'error'}
                        loading={props.metaPost.pending}
                        htmlType='submit'
                    >
                        {props.t('submit')}
                    </Button>
                </div>
            </div>
        </AntdForm>;
    }

    const validate = values => {
        try {
            validationSchema.validateSync(values, { abortEarly: false });
        } catch (e) {
            return e.inner.reduce((errors, error) => assoc(error.path, error.message, errors), {});
        }
    }

    const onSubmit = values => {
        props.onSubmit({
            values
        });
    }

    return <Modal
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
    >
        <LanguageContext.Provider value={props.language}>
            <div className='opd'>
                
                <div className='title'>
                    <span>{ props.t('sureQuestion') }</span>
                    <div className='close-btn' onClick={props.onRequestClose}><CloseOutlined /></div>
                </div>
                    <Form
                        subscription={{ submitting: true, valid: true, pristine: true, submitFailed: true }}
                        initialValues={{
                            SoglasieOPD: false,
                        }}
                        onSubmit={onSubmit}
                        validate={validate}
                        render={renderForm}
                        decorators={[ focusOnErrors ]}
                    />
            </div>
        </LanguageContext.Provider>
    </Modal>;
}

export default CancelOpdModal;
